import { z } from 'zod';
export const skillKeySchema = z.enum(['counting', 'reading', 'colors', 'shapes']);
export const skillProgressSchema = z.object({
    id: z.string(),
    childId: z.string(),
    skillKey: skillKeySchema,
    level: z.number().int().min(0),
    experience: z.number().int().min(0),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=skill.js.map